import { useLearningUserTrackCompletionStatusQueryQuery } from './learning-user-track-completion-status-query.v5.generated';

type TUseUserTrackCompletionStatusParams = {
  organizationTeamId: number;
  organizationId?: number;
  skip?: boolean;
};

export const useUserTrackCompletionStatus = ({
  organizationTeamId,
  organizationId,
  skip,
}: TUseUserTrackCompletionStatusParams) => {
  const { data, loading, error } =
    useLearningUserTrackCompletionStatusQueryQuery({
      variables: {
        input: {
          organization_team_id: organizationTeamId,
          organization_id: organizationId,
        },
      },
      skip: skip || !organizationTeamId,
      context: { clientName: 'v5' },
    });

  const completionStatus =
    data?.content_organization_team.user_track_completion_status;

  return {
    completed: completionStatus?.completed,
    // Only the requirements the admin switched on, already in the order of the
    // admin tab. A track with no rule configured makes the query error instead
    // of answering, so both that error and a missing payload land here as an
    // empty list and the caller falls back to the legacy criteria rows.
    // Nullable numbers are normalised to undefined per the "undefined over
    // null" rule.
    requirements: (completionStatus?.requirements ?? []).map(requirement => ({
      ...requirement,
      threshold: requirement.threshold ?? undefined,
      current_value: requirement.current_value ?? undefined,
    })),
    loading,
    error,
  };
};
